import { render } from "./SubmissionSuccessView.vue?vue&type=template&id=c89705d6&scoped=true"
const script = {}

import "./SubmissionSuccessView.vue?vue&type=style&index=0&id=c89705d6&scoped=true&lang=css"

import exportComponent from "/Users/basil/Documents/rishad/ncp_form/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c89705d6"]])

export default __exports__